import React from "react";
import timeSrc from "@default/assets/ui/time.svg?url";

const IconTime = () => {
  return <img src={timeSrc} alt={"Time"} className="icon time"/>;
}

export default IconTime;